export enum UserAction {
  UsersLoaded,
  UserDeleted,
  UserAdded
}
